import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Link as MuiLink } from '@mui/material';
import * as R from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ExternalLink = /*#__PURE__*/R.forwardRef(function (_ref, ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_jsx(MuiLink, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    underline: "none",
    sx: mergeSxProps({
      fontSize: function fontSize(theme) {
        return theme.typography.body1.fontSize;
      },
      fontWeight: function fontWeight(theme) {
        return theme.typography.fontWeightBold;
      },
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }, props.sx)
  }));
});